import styled from "styled-components";

import { ReactComponent as HamburgerLogo } from "@src/modules/App/Topbar/icons/hamburger.svg";

const Hamburger = styled(HamburgerLogo)`
  cursor: pointer;
`;

export default Hamburger;
